import React from "react";
import {NextRouter, useRouter} from "next/router";
import {ParsedUrlQuery} from "querystring";

export function getQueryFromRouter(router: NextRouter, queryKey: string) {
  return getQueryFromQueries(router.query, queryKey);
}

export function getQueryFromQueries(queries: ParsedUrlQuery, queryKey: string) {
  const queryItem = queries[queryKey];
  return Array.isArray(queryItem) ? queryItem[0] : queryItem;
}

export function useQuery(queryKey: string) {
  const router = useRouter();
  const { query } = router;
  const queryItem = query[queryKey];

  return React.useMemo(() => {
    return getQueryFromRouter(router, queryKey);
  }, [queryItem]);
}